import React from "react";
import {GenericErrorComponent, QuestionErrorComponent, RetryErrorComponent,} from "../../components";
import HttpError from "./http-error";

const handleErrorComponent = (error, callBackFn = () => {
}) => {
    if (error instanceof HttpError) {
        if (error.status) {
            switch (error.status) {
                case 401:
                    return <QuestionErrorComponent errorQuestion={error.data}/>;
                case 504:
                    return <RetryErrorComponent retryCallBack={callBackFn}/>;
                default:
                    return <GenericErrorComponent/>;
            }
        }
    }

    return <GenericErrorComponent/>;
};

export default handleErrorComponent;
